import { HammerGestureConfig } from '@angular/platform-browser';

interface HammerInstance {
  on(eventName: string, callback?: Function): void;
  off(eventName: string, callback?: Function): void;
}

export class MyHammerConfig extends HammerGestureConfig  {
  overrides = <any>{
    // override hammerjs default configuration
    pan: {threshold: 5}
  };

  buildHammer(element: HTMLElement): HammerInstance {
    const mc = new Hammer(element, {
      touchAction: element.dataset.touchAction ? element.dataset.touchAction : 'auto'
    });

    mc.get('pinch').set({enable: true});
    mc.get('rotate').set({enable: true});

    for (const eventName in this.overrides) {
      mc.get(eventName).set(this.overrides[eventName]);
    }

    return mc;
  }
}


// WEBPACK FOOTER //
// ./src/app/hammer.config.ts